let temporaryGoalsOcurrence = new Map();

export function addUnsaveGoalOcurrence(goal) {
  const alreadyUnsaved = temporaryGoalsOcurrence.has(goal);
  if (alreadyUnsaved) temporaryGoalsOcurrence.delete(goal);
  else temporaryGoalsOcurrence.set(goal, 1);
}

export function removeUnsaveGoalOcurrence(goal) {
  const alreadyUnsaved = temporaryGoalsOcurrence.has(goal);
  if (alreadyUnsaved) temporaryGoalsOcurrence.delete(goal);
  else temporaryGoalsOcurrence.set(goal, -1);
}

// biome-ignore lint/correctness/noUnusedVariables: <not used for now>
function resetTemporaryGoalsOcurrence() {
  temporaryGoalsOcurrence = new Map();
}
